import { FC, useEffect } from 'react';
import { BasicType } from './ts-config';
import { routersConfig } from '@/router/router';
import { getCookie } from '@lhb/cache';
import { dateFns, debounce } from '@lhb/func';
import { loadFinish } from '@lhb/bridge';
import { useAliveController } from 'react-activation';
import { clearInKeepRoutes } from '@/router/keep-alive-config';
import { isApp } from '@/common/utils/tools';
const routeList = routersConfig(); // 不能在jsx内执行，需要在Main函数之前就调用，才能获取到正确的页面组件

const targetPathnames = [
  '/footprinting/draw',
  '/passenger/draw',
];
const BasicLayout: FC<BasicType> = ({
  children,
  location
}) => {
  const { refresh } = useAliveController();
  // 路由切换时
  useEffect(() => {
    if (!location) return;
    const { to, from } = location;
    if (!to) return;
    const { pathname } = to;
    const targetPath = clearInKeepRoutes.find((item: any) => item.toPathname === pathname && item.formPathname === from.pathname);
    if (targetPath) {
      refresh(pathname);
    }
    // 查找匹配的路由配置
    const targetRoute = routeList?.find((item) => {
      return item.path === pathname;
    });
    if (!targetRoute) return;
    const result = targetRoute?.meta || {};
    const { url, urlName } = result;
    if (!(url && urlName)) return;
    // 埋点需求
    const employeeId = getCookie('EMPLOYEE_ID');
    const tenantId = getCookie('TENANT_ID');
    const msg: any = {
      report_time: dateFns.currentTime('', false),
      url,
      urlName
    };
    if (employeeId) msg.user_id = employeeId;
    if (tenantId) msg.tenant_id = tenantId;
    window.LHBbigdata.send({
      msg
    });
  }, [location]);

  useEffect(() => {
    // console.log(`ocation.to.pathname`, location.to.pathname);
    if (isApp() && !targetPathnames.includes(location.to.pathname)) {
      setTimeout(() => { // 兜底
        // 通知原生关闭骨架屏
        loadFinish();
      }, 800);
    }
    setTimeout(() => {
      window.getScript('iconUI');
      window.getScript('iconApp');
      window.getScript('iconAppNew');
      window.getCss('iconAppNewCss');
      window.getScript('iconPC');
      window.getScript('iconPCNew');
    }, 300);
    // 强制刷新根元素的font-size(三方应用内，偶发性的rem失效)
    window.addEventListener('resize', debounce(() => {
      const screenWidth = window.screen.width;
      const docFontSize = screenWidth / 10;
      docFontSize && (document.documentElement.style.fontSize = `${docFontSize}px`);
    }, 150));
  }, []);
  return (
    <>
      {children}
    </>
  );
};

export default BasicLayout;
